var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConversationIndex", { attrs: { index: _vm.index } }),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { staticClass: "justify-end" },
        [
          _c(
            "Link",
            { attrs: { href: _vm.route("conversation.show") } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", small: "", rounded: "", color: "accent" },
                },
                [_vm._v("Go To Messages")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }